import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useState } from "react";

const SyncTileModal = () => {
  const { setInvisible } = useModalActions("TILE_SYNC_MODAL");
  const { tileName, onConfirm } = useModalState("TILE_SYNC_MODAL") as {
    tileName?: string;
    onConfirm?: () => Promise<void> | void;
  };
  const [isSyncing, setIsSyncing] = useState(false);

  const handleConfirm = () => {
    setIsSyncing(true);
    Promise.resolve(onConfirm?.()).finally(() => {
      setIsSyncing(false);
      setInvisible();
    });
  };

  return (
    <ModalPrompt
      modalId="TILE_SYNC_MODAL"
      dialogClassName="sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
      isLoading={isSyncing}
      button={{
        primaryButtonText: "Yes, Sync",
        secondaryButtonText: "Cancel",
        primaryButtonDisabled: isSyncing,
        primaryCallback: handleConfirm,
        secondaryCallback: () => setInvisible(),
        shouldHideOnClick: false,
        primaryButtonClassname: "bg-[#1a3c87]",
      }}
      title="Sync with Live"
      content={
        <p className="text-sm text-gray-600">
          Confirm to sync <span className="font-semibold text-gray-900">{tileName || "this tile"}</span> with Live.
        </p>
      }
    />
  );
};

export default SyncTileModal;
